















































import { Component, Vue } from "vue-property-decorator";
import { Checkbox, CheckboxGroup, Button,Dialog } from "vant";
import NetErrorPage from "@/components/NetErrorPage.vue";
import { namespace } from "vuex-class";
import { nextTick } from "vue/types/umd";
const createAccountModule = namespace("createAccount");

@Component({
  name: "ServiceOpening",
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
	[Dialog.Component.name]: Dialog.Component,
    NetErrorPage: NetErrorPage
  }
})
export default class ServiceOpening extends Vue {
  @createAccountModule.Getter("examine_list") examine_list: any;
  serverList = [];
  serverIdListchecked: any = [];
  showPage = false;

  isLoading = true;
  requestFail = true;
  idListResult = [];

  open_dialog: boolean = false;

  activated() {
    /**如果首次请求失败后再次进入重新请求 */
    if (this.requestFail) {
      this.getServerList();
    }

  }
  created(){
	(this as any).$nextTick(() =>{
		this.getWhiteList()
	})
  }

  getWhiteList(){
	  (this as any).$apis.getWhiteList().then(res =>{
		  
		  // if(res.white_manager === 0){
			 // (this as any).serverList.forEach(item =>{
				// item.children = item.children.filter(items => items.id === 3)
			 // })
		  // }
		  if(res.white_open === 1 && res.white_manager === 0){
			 (this as any).serverList.forEach(item =>{
			 	item.children = item.children.filter(items => items.id === 3)
			 })
		  }
		  // if(res.white_open === 1 && res.white_manager === 0){
			 // (this as any).serverList.forEach(item =>{
			 // 	item.children = item.children.filter(items => items.id === 3)
			 // })
		  // }else if(res.white_open === 1 && res.white_manager === 1){
			 // (this as any).serverList.forEach(item =>{
			 // 	item.children = item.children.filter(items => items.id === 6)
			 // })
		  // }
	  })
  }


  getServerList() {
    this.isLoading = true;
    (this as any).$apis
      .getServerList()
      .then(res => {
        this.requestFail = false;
        this.showPage = true;
		
        this.serverList = this.setServerListInitCheckStatus(res);



      })
      .catch(e => {
        this.requestFail = true;
        
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
  checkChange(){
	(this as any).setSeverIdListChecked((this as any).serverList);
	(this as any).idListResult = (this as any).serverIdListchecked
  }
  setServerListInitCheckStatus(list) {
	
	// list.forEach(item =>{
	// 	
	// })
    list.forEach(item => {
      if (item.level !== 1) {
        item.isChecked = false;
      }
      if (item.children) {
        this.setServerListInitCheckStatus(item.children);
      }
	  if(item.isChecked){
		  (this as any).idListResult.push(item.id)
	  }
    });
    return list;
  }

  handleSaveServerInfo() {
	const derivative = this.examine_list.derivative

    this.serverIdListchecked = [];
    this.setSeverIdListChecked(this.serverList);
    const isVerify = this.serverIdListchecked.some(item => {
      return item.id == 3;
    });
    // if (!isVerify) {
    //   return this.$toast(
    //     this.$t("open_account.service_opening.verify_fail_text")
    //   );
    // }
    const idList = this.serverIdListchecked.map(item => {
      return item.id;
    });
	if(derivative.t0.value === 1 && idList.indexOf(3) !== -1){
	   (this as any).serverList[0].children[0].isChecked = false
    this.open_dialog = true
		// Dialog.confirm({
    //   ["className" as any]: 'open_dialog',
		//   ["title" as any]:'由于您不了解衍生产品的性质和风险，无法开通期货及期权账户(香港及环球)服务 ，请知悉',
		//   ["confirmButtonText" as any]:'知道了',
		//   ["showConfirmButton" as any]:true,
		//   ["showCancelButton" as any]:false
		// })
	}else{
		(this as any).$apis
		  .saveServerInfo({
		    server_id: idList.join(",")
		  })
		  .then(() => {
		    const userInfo =  (this as any).$localstorage.get("userInfo") || {};
		    let path;
		    if(userInfo.is_model_hl) {
		      path = '/electronic-sign'
		    } else {
		      path = "/trade-password-setting"
		    }
		    this.$router.push({
		      path,
		      query: this.$route.query
		    });
		  })
		  .catch(e => {
		    
		  });
	}

  }

  setSeverIdListChecked(list) {
	this.serverIdListchecked = []
    list.forEach(item => {
      
      if (item.level !== 1 && item.isChecked) {
        this.serverIdListchecked.push({
          id: item.id,
          name: item.name
        });
        
      }
      if (item.children) {
        this.setSeverIdListChecked(item.children);
      }
    });
  }
}
